import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class CategoryComponent  implements OnInit {
  @Input() category: any = {};

  constructor() { }

  ngOnInit() {}

}
